import React, { useEffect } from "react";
import OrderTable from "./MaterialTable/OrderTable";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "./utility/constants";
import CardLoaderComponent from "../../../CardLoaderComponent";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Tooltip } from "@mui/material";
import { IconButton } from "@mui/material";

const QualityHoldWidget = (props) => {
  const { tableData, isLoading, isQualityHoldDataAvailable } = props;

  useEffect(() => {}, []);

  return (
    <>
      <div className="flex justify-between items-center">
        <div className="flex items-center gap-1">
          <h2 className="text-zinc-900 text-xl font-semibold font-['Open Sans'] leading-7">
            Blocked Orders
          </h2>
          <h2 className="text-zinc-900 text-xl font-semibold font-['Open Sans'] leading-7">
            ({tableData.length})
          </h2>
        </div>
        <div className="pl-2 py-2 bg-white/opacity-0 rounded justify-center items-center flex">
          <a
            className="text-lime-700 text-sm font-semibold font-['Open Sans'] leading-tight"
            href="/forwarder/avis"
          >
            <Tooltip title="Go to Avis page">
              <IconButton>
                <ArrowForwardIcon />
              </IconButton>
            </Tooltip>
          </a>
        </div>
      </div>
      <div className="self-stretch">
        <ThemeProvider theme={theme}>
          {isLoading && (
            <CardLoaderComponent
              desc="quality hold orders"
              subtitle="This might take a while"
            />
          )}
          {!isLoading && isQualityHoldDataAvailable && (
            <div className="h-44">
              <OrderTable tableData={tableData}></OrderTable>
            </div>
          )}
          {!isQualityHoldDataAvailable && !isLoading && (
            <h6 className="flex justify-center flex-col h-44 text-center">
              No records to display
            </h6>
          )}
        </ThemeProvider>
      </div>
    </>
  );
};

export default QualityHoldWidget;
